export default __webpack_public_path__ + "static/media/logo_white_background.6d194b17.png";